import { useState } from "react";
import api from "../services/api";
import { toast } from "react-hot-toast";

export function useCrud({ rotaLista, rotaUm }) {

  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [lastParams, setLastParams] = useState({});

  const listar = async (params = {}) => {
  try {
    setLoading(true);
    setError(null);

    setLastParams(params); // 👈 GUARDA OS PARAMS

    const response = await api.get(rotaLista, { params });
    setDados(response.data);

  } catch (err) {
    console.error(err);
    setError("Erro ao carregar dados");
    toast.error("Erro ao carregar dados");
  } finally {
    setLoading(false);
  }
};

  const buscarUm = async (params = {}) => {

    try {

      setLoading(true);

      const response = await api.get(rotaUm, { params });

      return response.data;

    } catch (err) {

      console.error(err);
      toast.error("Erro ao carregar registro");

    } finally {
      setLoading(false);
    }

  };

  const criar = async (data) => {

    try {

      setLoading(true);

      await api.post(rotaLista, data);

      toast.success("Registro criado");

      await listar(lastParams);

    } catch (err) {

      console.error(err);
      toast.error("Erro ao criar registro");

    } finally {
      setLoading(false);
    }

  };

  const editar = async (data) => {

    try {

      setLoading(true);

      await api.put(rotaLista, data);

      toast.success("Registro atualizado");

      await listar(lastParams);

    } catch (err) {

      console.error(err);
      toast.error("Erro ao atualizar registro");

    } finally {
      setLoading(false);
    }

  };

  const excluir = async (params) => {

    try {

      setLoading(true);

      await api.delete(rotaLista, { params });

      toast.success("Registro excluído");

      await listar(lastParams);

    } catch (err) {

      console.error(err);
      toast.error("Erro ao excluir registro");

    } finally {
      setLoading(false);
    }

  };

  return {
    dados,
    loading,
    error,
    listar,
    buscarUm,
    criar,
    editar,
    excluir
  };

}